<template>
  <vxe-grid
    border
    show-overflow
    resizable
    ref="depositRecordTableRef"
    class="vxe-table-element"
    size="mini"
    align="center"
    :auto-resize="true"
    :data="data"
    :valid-config="{ autoPos: true, message: 'inline' }"
    height="300"
  >
    <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
    <vxe-table-column
      v-for="(item, index) in columns"
      :key="index"
      :type="item.type"
      :fixed="item.fixed"
      :field="item.field"
      :title="item.title"
      :width="item.width"
    >
      <!-- <template v-slot="{ row }">
                <span v-if="item?.field == 'qtyUnit'">{{
                  getUnitName('qty', row[item.field])
                }}</span>
                <span v-else-if="item?.field == 'grossWeightUnit'">{{
                  getUnitName('gross', row[item.field])
                }}</span>
                <span v-else-if="item?.field == 'volumeUnit'">{{
                  getUnitName('volume', row[item.field])
                }}</span>
                <span v-else>{{ row[item.field] }}</span>
              </template> -->
    </vxe-table-column>
  </vxe-grid>
</template>

<script>
  export default {
    name: 'DepositAuditRecordTable',
    props: {
      tableData: {
        type: Array,
        default: () => [],
      },
    },
    watch: {
      tableData: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          }
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {},
    data() {
      return {
        data: [],
        columns: [
          {
            field: 'optUserName',
            title: '操作人',
            width: '250',
          },
          {
            field: 'optType',
            title: '操作',
            width: '250',
          },
          {
            field: 'optTime',
            title: '操作时间',
            width: '300',
          },
          {
            field: 'info',
            title: '审批信息',
            width: '500',
          },
        ],
      };
    },
    methods: {
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.depositRecordTableRef;
        return $table.getTableData().fullData;
      },
      // 反填数据
      fullTableData(val) {
        if (val && val.length) {
          this.data = val;
        } else {
          this.data = [];
        }
      },
    },
  };
</script>
